<template>
  <v-row no-gutters class="secondary-card pa-3" style="width: 100%">
    <v-col cols="12" class="text-left">
      <div class="subtitle-2">{{title}}</div>
    </v-col>
    <v-col cols="12">
      <div class="carousel">
        <div class="carousel-item" v-for="(appointment, i) in appointments" :key="i">
          <client-attention-card :disabled="disabled" @click="$emit('click', appointment)" :appointment="appointment">

            <template v-slot:client:avatar="{client, appointment}">
              <slot name="client:avatar" :client="client" :appointment="appointment">
                <v-img :src="client.avatar" />
              </slot>
            </template>

            <template v-slot:client:name="{client, appointment}">
              <slot name="client:name" :client="client" :appointment="appointment">
                {{client.first_name}} {{client.last_name}}
              </slot>
            </template>

            <template v-slot:details="{appointment}">
              <slot name="appointment:details" :appointment="appointment" />
            </template>
          </client-attention-card>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>

  import ClientAttentionCard from "@/components/appointments/attention/home_screen/ClientAttentionCard";
  export default {
    name: "ClientAttentionCarousel",
    components: {ClientAttentionCard},
    props: {
      title:{
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      appointments: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {

      }
    },

    methods: {

    },
    computed: {

    },
  }
</script>

<style scoped>

  .carousel{
    display: inline-block;
    width: 100%;
    padding: 5px;
    text-align: left;
    min-height: 80px;
    overflow-x: auto;
    overflow-y: visible;
    white-space: nowrap;
  }

  .carousel-item{
    display: inline-block;
    width: 280px !important;
    padding: 5px 4px 15px 4px;
  }

</style>
